/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { cva } from "@panda/css";

export const sectionContentContainer = cva({
	base: {
		position: "relative",
		marginInline: "auto",
		width: "100%",
		maxWidth: `cosmos.article.sm`,
		smDown: {
			maxWidth: "100%",
		},
		"&& .section-container": {
			paddingInline: "0",
			paddingBlock: "0",
			overflowX: "unset",
		},
	},
	variants: {
		wide: {
			true: {
				maxWidth: "cosmos.article.md",
			},
		},
		centered: {
			true: {
				alignItems: "center",
				textAlign: "center",
			},
		},
	},
});
